import axios from 'axios';

export default axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export const apiRoutes = {
  EXPORT_RECOMPUTATIONS_STATISTICS: { url: '/statistics/recomputations' },
  EXPORT_DELIVERIES_STATISTICS: { url: '/statistics/deliveries' },
};
